import { render, staticRenderFns } from "./PlantRegisterAdmin.vue?vue&type=template&id=360cee65&scoped=true&"
import script from "./PlantRegisterAdmin.vue?vue&type=script&lang=js&"
export * from "./PlantRegisterAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PlantRegisterAdmin.vue?vue&type=style&index=0&id=360cee65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360cee65",
  null
  
)

export default component.exports